<div class="relative-div">
    @if (loading()) {
    <div class="spinner-overlay">
        <mat-spinner></mat-spinner>
    </div>
    }

    <table mat-table [dataSource]="attendeesDataSource" matSort matSortActive="registrationSeqNum"
        matSortDirection="asc">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
            <td mat-cell *matCellDef="let r"> {{r.id}} </td>
        </ng-container>
        <ng-container matColumnDef="registrationSeqNum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
            <td mat-cell *matCellDef="let r"> {{r.registrationSeqNum}} </td>
        </ng-container>
        <ng-container matColumnDef="registrationDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Registration date</th>
            <td mat-cell *matCellDef="let r"> {{r.registrationDate | date: 'dd/MM/yyyy'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="organisation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Organisation</th>
            <td mat-cell *matCellDef="let r"> {{r.organisation }}
            </td>
        </ng-container>
        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>First name</th>
            <td mat-cell *matCellDef="let r"> {{r.firstName }}
            </td>
        </ng-container>
        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last name</th>
            <td mat-cell *matCellDef="let r"> {{r.lastName }}
            </td>
        </ng-container>
        <ng-container matColumnDef="jobTitle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Job title</th>
            <td mat-cell *matCellDef="let r"> {{r.jobTitle }}
            </td>
        </ng-container>
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let r"> {{r.email }}
            </td>
        </ng-container>
        <ng-container matColumnDef="confirmationSentOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Confirmed on</th>)
            <td mat-cell *matCellDef="let r">
                @if (r.confirmationSentOn) {
                {{r.confirmationSentOn | date: 'dd/MM/yyyy'}}
                } @else {
                Unconfirmed
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Actions </th>
            <td mat-cell *matCellDef="let r">
                <button matIconButton [style.color]="r.confirmationSentOn? '#007bff': '#007bff'"
                    title="{{!r.confirmationSentOn ? 'Send confirmation' : 'Re-send confirmation'}}"
                    (click)="sendConfirmation(r)">
                    <mat-icon>{{!r.confirmationSentOn ? 'email' : 'forward_to_inbox'}}</mat-icon>
                </button>
                <button matIconButton [style.color]="'red'" title="Delete" (click)="deleteAttendee(r)">
                    <mat-icon>delete</mat-icon>
                </button>                
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data available</td>
        </tr>
    </table>
    <mat-paginator #attendeePaginator [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="showFirstLastButtons"></mat-paginator>
</div>